<!--模板-->
<template>
  <div id="encounter">
    <!-- **banner背景图 -->
    <div class="zwcWidth bg">
      <div class="flex">
        <!--<div class="shade">-->
        <!--<div style="display: table-cell;vertical-align: middle;text-align: center;">-->
        <h1 style="font-size: 85px;text-shadow:5px 2px 6px #000;">偶遇结伴</h1>
        <h3 style="text-shadow:5px 2px 6px #000;">一个人旅行并不孤单，孤单的是那时候你并不想一个人旅行～</h3>
        <!--&lt;!&ndash;<el-input placeholder="寻找其它目的地城市" v-model="input5" class="input-with-select">&ndash;&gt;-->
        <!--&lt;!&ndash;<el-button slot="append" icon="el-icon-search"></el-button>&ndash;&gt;-->
        <!--&lt;!&ndash;</el-input>&ndash;&gt;-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </div>
    <!-- ***列表 -->
    <div class="sec_guide_container pb--50 mid clearfix">
      <div class="lay-gd-main fl">
        <div class="bx-going-activity">
          <div class="going-ct">
            <ul class="js-bg-row">
              <li class="hover_bg" v-for="(item,index) of DynamicList.data" :key="index" @click.stop="dynamicBtn(item)">
                <a class="js-joinNow">
                  <div class="bx-lt fl">
                    <div class="title">
                      <h2>#{{item.dynamicStart | GetTime}}# 「{{item.endCity}} - 求偶遇求结伴」</h2>
                      <span class="btn_going" v-if="(Date.parse(new Date())/1000  > item.dynamicStart)  &&  (Date.parse(new Date())/1000  < item.dynamicEnd)">招募中...</span>
                      <span class="btn_going" style="color: #9B9B9B;border: 1px solid #9B9B9B" v-if="(Date.parse(new Date())/1000 > item.dynamicStart)  && (item.dynamicEnd < Date.parse(new Date())/1000)">旅行结束...</span>
                    </div>
                    <h3 class="line cor" v-if="item.startCity"><b>路线：{{item.startCity}} ~ {{item.endCity}}</b></h3>
                    <div class="trip">
                      <p><label>[行程时间]</label> <em>[人数]</em></p>
                      <p><label class="cor">{{item.dynamicStart | GetTime}} ~ {{item.dynamicEnd ? item.dynamicEnd : '返程未定' | GetTime}}<span v-if="item.dynamicEnd">（{{(item.dynamicEnd - item.dynamicStart) /86400 +1}}天）</span></label> <em>不限</em></p>
                    </div>
                    <div class="desc">
                      <p style="margin: 10px 0">📢<span v-if="item.dynamicLabel"> [ {{item.dynamicLabel}} ] </span>{{item.dynamicContext}}</p>
                      <div class="listImg" v-if="item && item.dynamicImg.length > 0 ">
                        <img v-for="(img,key) of item.dynamicImg" :key="key" :src="img" alt="">
                      </div>
                    </div>
                  </div>
                  <!--头像-->
                  <div class="bx-rt fr" @click.stop="nameBtn(item.userInfo.uid)">
                    <a class="uimg"><img :src="item.userInfo.avatar" height="120" width="120" /></a>
                    <p class="name">"{{item.userInfo.nickname}}"</p>
                    <p class="sex">{{item.userInfo.gender == 0 ? '（女）' : '（男）'}} <em>{{item.userInfo.birthdayText}}岁</em></p>
                  </div>
                </a>
              </li>
            </ul>
            <p style="text-align: right">
              <el-pagination background @size-change="handleSizeChange" @current-change="pageChange" :current-page="page" :page-sizes="[30, 50, 80, 100]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="totalData">
              </el-pagination>
            </p>
          </div>
        </div>
      </div>
      <div class="lay-gd-side fr">
        <div class="bx-side i-look-world mt--30" @click="addBtn()">
          <div class="adimg"><img src="../../../static/images/placeholder/ad-look-world.jpg" height="180" width="320" /></div>
          <a class="btn_launch js-launchPartner">🤚发布偶遇</a>
        </div>
        <!-- //热门攻略-->
        <!--<div class="bx-side hot-strategy">
              <div class="stg-inner">
                <h2 class="title clearfix"><em class="fl">热门旅游攻略</em> <a class="fr" href="#">更多»</a></h2>
                <ul class="stg_list">
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                  <li class="ellipsis"><a href="#"><em>[美食攻略]</em> 广州市区里面有什么东西比较好吃</a></li>
                </ul>
              </div>
            </div>  -->
        <!-- //热门景点-->
        <!--<div class="bx-side hot-spots">
             <div class="spot-inner">
               <h2 class="title clearfix"><em class="fl">热门旅游景点</em> <a class="fr" href="#">更多»</a></h2>
               <ul class="spots_list">
                 <li>
                   <p><b>广州塔</b></p>
                   <p><span class="addr">广州市海珠区</span></p>
                 </li>
                 <li>
                   <p><b>广州塔</b></p>
                   <p><span class="addr">广州市海珠区</span></p>
                 </li>
                 <li>
                   <p><b>广州塔</b></p>
                   <p><span class="addr">广州市海珠区</span></p>
                 </li>
                 <li>
                   <p><b>广州塔</b></p>
                   <p><span class="addr">广州市海珠区</span></p>
                 </li>
               </ul>
             </div>
           </div>  -->
      </div>
    </div>
    <!--详情-->
    <el-dialog title="偶遇详情" :visible.sync="particulars" width="60%" s center>
      <div class="bx-going-activity">
        <div class="going-ct">
          <ul class="js-bg-row">
            <li>
              <a class="js-joinNow">
                <div class="bx-lt fl">
                  <div class="title">
                    <h2>#{{DynamicData.dynamicStart | GetTime}}# 「{{DynamicData.endCity}} - 求偶遇求结伴」</h2>
                    <span class="btn_going" v-if="(Date.parse(new Date())/1000  > DynamicData.dynamicStart)  &&  (Date.parse(new Date())/1000  < DynamicData.dynamicEnd)">招募中...</span>
                    <span class="btn_going" style="color: #9B9B9B;border: 1px solid #9B9B9B" v-if="(Date.parse(new Date())/1000 > DynamicData.dynamicStart)  && (DynamicData.dynamicEnd < Date.parse(new Date())/1000)">旅行结束...</span>
                  </div>
                  <h3 class="line cor"><b>路线：{{DynamicData.startCity}} ~ {{DynamicData.endCity}}</b></h3>
                  <div class="trip">
                    <p><label>[行程时间]</label> <em>[人数]</em></p>
                    <p><label class="cor">{{DynamicData.dynamicStart | GetTime}} ~ {{DynamicData.dynamicEnd ? DynamicData.dynamicEnd : '返程未定' | GetTime}}<span v-if="DynamicData.dynamicEnd">({{(DynamicData.dynamicEnd - DynamicData.dynamicStart) /86400}}天)</span></label> <em>不限</em></p>
                  </div>
                  <div class="desc">
                    <p style="margin: 10px 0">📢<span v-if="DynamicData.dynamicLabel"> [ {{DynamicData.dynamicLabel}} ] </span>{{DynamicData.dynamicContext}}</p>
                    <div class="listImg" v-if="DynamicData && DynamicData.dynamicImg.length > 0 ">
                      <img v-for="(img,key) of DynamicData.dynamicImg" :src="img" alt="" @click="imgBtn(img)">
                    </div>
                  </div>
                </div>
                <!--头像-->
                <div class="bx-rt fr name_rt" v-if="DynamicData" @click.stop="nameBtn(DynamicData.userInfo.uid)">
                  <a class="uimg"><img :src="DynamicData.userInfo.avatar" height="120" width="120" /></a>
                  <p class="name">{{DynamicData.userInfo.nickname}}</p>
                  <p class="sex">{{DynamicData.userInfo.gender == 2 ? '（女）' : '（男）'}} <em v-if="DynamicData.userInfo.dateBirthStr != null">{{DynamicData.userInfo.dateBirthStr}}岁</em></p>
                </div>
              </a>
            </li>
            <li>
              <h4>全部回复</h4>
              <ul>
                <li class="reply_bg" v-if="DynamicData && DynamicData.replyList.length != 0" v-for="(item,index) of DynamicData.replyList" :key="index">
                  <div class="name">
                    <div>
                      <img :src="item.userInfo.headImg" alt="">
                    </div>
                    <div>
                      <p>{{item.userInfo.name}}</p>
                      <p>{{item.userInfo.sex == 0 ? '女' : '男'}}</p>
                    </div>
                  </div>
                  <div>
                    {{item.introduce}}
                    <div class="reply_two" v-if="item.replyList.length > 0">
                      <p v-for="(text,key) of item.replyList"><span>{{text.userInfo.name}}：</span>{{text.introduce}}<i @click="addToText(item)">（回复Ta)</i></p>
                    </div>
                    <p class="name_reply"><span @click="addToText(item)">【回复此条Ta】</span></p>
                  </div>
                </li>
              </ul>
              <div class="reply_btn">
                <el-input placeholder="回复发布者：请输入回复内容" v-model="setVal" clearable>
                </el-input>
                <el-button type="primary" @click="text_btn">回复Ta</el-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <!--    查看图片-->
    <el-dialog title="查看图片" :visible.sync="viewImage" style="z-index:99999" :modal="false" width="70%">
      <div class="img_BG" style="z-index:99999">
        <img :src="img_src" style="width:100%" alt="">
      </div>
    </el-dialog>
    <!--发布偶遇-->
    <el-dialog title="发布偶遇" :visible.sync="releaseShow" width="60%" center>
      <div class="release_bg">
        <p>
          <span class="demonstration"></span>
          <el-date-picker v-model="releaseTime" type="daterange" range-separator="至" start-placeholder="出发日期" end-placeholder="结束日期">
          </el-date-picker>
        </p>
        <p><span></span><span class="city_add">
            <el-input style="width: 130px" v-model="city_star" placeholder="出发城市"></el-input>
          </span> <span style="font-size: 22px">⇒</span> <span class="city_add">
            <el-input style="width: 130px" v-model="city_end" placeholder="目的地城市"></el-input>
          </span></p>
        <div class="release_text">
          <el-input type="textarea" :rows="5" placeholder="请输入您想说的偶遇内容" v-model="release_text">
          </el-input>
          <div>
            <el-upload action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-success="imgListSuc" :file-list="img_list" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
        </div>
        <div style="text-align: center;width: 100%">
          标签：
          <el-radio v-model="labelData" :label="item" border v-for="(item,index) of labelList" :key="index">{{item}}</el-radio>
        </div>
        <div class="btn">
          <el-button type="primary" @click="releaseAdd">发布偶遇</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<!--JS-->
<script>
import http from 'api/api'
export default {
  data () {
    return {
      particulars: false,
      DynamicList: '',
      nameDynamic: '',
      DynamicData: '',
      addCode: '',
      addCodeShow: false,
      setVal: '',
      optionData: '',
      releaseShow: false,
      dialogImageUrl: '',
      dialogVisible: false,
      labelList: [
        "求捎带", "求拼车", "求拼房", "求偶遇", "我出费用", "费用你出", "一起去", '只限男生', '只限女生', '男女不限'
      ],
      labelData: '',
      releaseTime: '',
      city_star: '',
      city_end: '',
      release_text: '',
      img_list: [],
      fileList: [],
      totalData: 0,
      page: 1,
      pageSize: 30,
      viewImage: false,
      img_src: ''
    }
  },
  methods: {
    imgBtn (img) {
      this.viewImage = true
      this.img_src = img
    },
    handleSizeChange (val) {
      this.pageSize = val
      // 获取服务服务列表
      this.getList()
      console.log(`每页 ${val} 条`);
    },
    pageChange (val) {
      this.page = val
      // 获取服务服务列表
      this.getList()
      console.log(this.page, val, "翻页")
    },
    imgListSuc (response, file, fileList) {
      this.fileList = fileList
    },
    addBtn () {
      if (localStorage.getItem("pbw_user_pc_uid")) {
        this.releaseShow = true
      } else {
        this.$router.push('/login')
      }
    },
    formatDateTime (date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? ('0' + minute) : minute;
      return y + '-' + m + '-' + d + ' ' + '00' + ':' + minute + ':00';
    },
    // 发布偶遇
    releaseAdd () {
      let vm = this
      console.log(vm.releaseTime)
      console.log(vm.formatDateTime(vm.releaseTime[0]))
      console.log(vm.release_text)
      console.log(vm.labelData)
      console.log(vm.img_list, "66666666666")
      console.log(vm.fileList)
      if (vm.releaseTime == '') {
        vm.$message.warning("请选择出发时间")
        return
      }
      if (vm.city_star == '') {
        vm.$message.warning("请输入出发城市")
        return
      }
      if (vm.city_end == '') {
        vm.$message.warning("请输入目的地城市")
        return
      }
      if (vm.release_text == '') {
        vm.$message.warning("请输入您的偶遇内容")
        return
      }
      // 获取图片
      let img_file = []
      for (let item of vm.fileList) {
        img_file.push(item.response.data.fileStr)
      }
      // 发布偶遇
      insertUserDynamic({
        dynamicType: 2,
        dynamicContext: vm.release_text,
        dynamicImg: img_file.join(','),
        dynamicStart: vm.formatDateTime(vm.releaseTime[0]),
        dynamicEnd: vm.formatDateTime(vm.releaseTime[1]),
        startCity: vm.city_star,
        endCity: vm.city_end,
        dynamicLabel: vm.labelData
      }).then((res) => {
        if (res.code == '000000') {
          // 获取偶遇列表
          vm.getList()
          vm.releaseShow = false
          vm.$message({
            message: '发布成功',
            type: 'success'
          });
        } else {
          vm.$message.warning(res.msg)
        }
      })
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview (file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    nameBtn (uid) {
      this.$router.push('/homePage?nameCode=' + uid)
    },
    // 子回复
    addToText (item) {
      let vm = this
      let name = '@' + item.userInfo.name + '：'
      console.log(item.code, "77777777777")
      vm.addCode = item.code
      vm.setVal = name
      vm.addCodeShow = true
    },
    text_btn () {
      let vm = this
      // 回复
      if (!vm.addCodeShow) {
        insertUserReply({
          dynamicCode: vm.nameDynamic,
          introduce: vm.setVal
        }).then((res) => {
          if (res.code == '000000') {
            vm.$message({
              message: '已发送',
              type: 'success'
            });
            // 获取列表
            vm.getList()
            vm.setVal = ''
          } else {
            vm.$message.warning(res.msg)
          }
        })
      } else {
        // 子回复
        insertUserReply({
          introduce: vm.setVal,
          dynamicCode: vm.nameDynamic,
          replyMyCode: vm.addCode
        }).then((res) => {
          if (res.code == '000000') {
            vm.$message({
              message: '已发送',
              type: 'success'
            });
            // 获取列表
            vm.getList()
            vm.setVal = ''
          } else {
            vm.$message.warning(res.msg)
          }
        })
      }
    },
    dynamicBtn (item) {
      this.particulars = true
      this.nameDynamic = item._id
      // 详情
      http.GET('/jw-function', {
        module: 'nearby',
        operation: 'nearbyText',
        id: item._id,
      }).then((res) => {
        this.DynamicData = res.data[0]
      })
    },
    getList () {
      // 获取偶遇列表
      http.GET('/jw-function', {
        module: 'nearby',
        operation: 'nearbyList',
        dynamicType: 2,
        limit: 8,
        offset: 0
      }).then((res) => {
        this.DynamicList = res
      })
    }
  },
  mounted () {
    // 查看详情
    if (this.$route.query.nameDynamic) {
      this.nameDynamic = this.$route.query.nameDynamic
      this.particulars = true
      // 获取详情
      http.GET('/jw-function', {
        module: 'nearby',
        operation: 'nearbyText',
        id: this.$route.query.nameDynamic
      }).then((res) => {
        this.DynamicData = res.data[0]
      })
    }
    // 获取偶遇列表
    this.getList()
  },
  filters: {
    GetTime (value) {
      var time = new Date(value * 1000);
      function add0 (m) {
        return m < 10 ? '0' + m : m
      }
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      var timeResult = add0(m) + '月' + add0(d) + '日';
      if (timeResult == '1970-01-01' || timeResult == '1970-01-02') {
        return '--'
      } else {
        return timeResult
      }
    },
  }
};
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
.cor {
  color: $fontColor !important;
}
.release_bg {
  > p {
    text-align: center;
  }
  > div {
    width: 450px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .btn {
    text-align: center;
  }
  .release_text {
    width: 461px;
    margin: 0 auto;
    margin-top: 20px;
    border-top: 3px solid #f5f5f5;
    padding-top: 20px;
    > div {
      margin-top: 10px;
    }
  }
  p {
    margin: 30px 0;
  }
  .city_add {
    font-size: 20px;
    padding: 5px 50px;
  }
}
.hover_bg {
  cursor: pointer;
  margin: 30px 7px 50px 7px !important;
  box-sizing: border-box;
}
.hover_bg:hover {
  box-shadow: 2px 2px 2px 3px #8d65ea !important;
}
.reply_btn {
  display: flex;
  padding: 30px 0;
}
.name_reply {
  display: flex;
  justify-content: flex-end;
  color: #005cf7;
  span {
    cursor: pointer;
  }
}
.reply_two {
  margin: 10px 0;
  p {
    margin: 5px 0;
  }
  span {
    margin-right: 10px;
    color: #9b9b9b;
  }
  i {
    margin-left: 20px;
    color: #005cf7;
  }
}
.reply_two {
  background: #f5f5f5;
  padding: 10px;
}
.reply_bg {
  border: none !important;
  box-shadow: 2px 3px 0px -2px #ddd !important;
  margin-bottom: 10px !important;
  display: flex;
  > div:last-child {
    flex: 1;
    padding-top: 20px;
  }
  .name {
    display: flex;
    width: 230px;
    align-items: center;
  }
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
/*导航下大背景*/
.bg {
  background: url(../../../static/images/title/encounter.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 500px;
  display: flex;
}
.bg .flex {
  align-self: center;
  margin: auto;
}
.bg .flex h1 {
  color: #ffffff;
  font-size: 30px;
  text-align: center;
}
.bg .flex h3 {
  color: #ffffff;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}
.bg .flex .shade {
  width: 800px;
  height: 100px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  display: table;
  margin-top: 15px;
  padding-bottom: 30px;
}
/* ==== 20160518 伴行-玩行-陪行(最终版) {{{ ==== */
/* >>>> 伴行页面 */
/*地址-日期选择*/
.listImg {
  width: 833px;
}
.listImg img {
  width: 150px;
  height: 150px;
  border-radius: 5px;
  padding: 10px 7px;
}
.trip1 {
  border: 1px solid #ddd;
  padding: 10px;
  width: 80%;
  margin: 10px 0;
}
.sec_sel_addr_date {
  filter: progid:DXImageTransform.Microsoft.gradient(enabled='true', startColorstr='#70333333', endColorstr='#70333333');
  background: rgba(31, 31, 31, 0.3);
  float: left;
  margin-top: -90px;
  height: 90px;
  width: 100%;
  position: relative;
}
.sec_sel_addr_date .zone_addr_date {
  margin-top: 25px;
  height: 40px;
  width: 1145px;
}
.sec_sel_addr_date .zone_addr_date ul li.col {
  background: #fff;
  display: inline-block;
  float: left;
  height: 40px;
  width: 25%;
}
.sec_sel_addr_date .zone_addr_date ul li.col input {
  background: url(../../../static/images/icon-datepicker-bg2.png) no-repeat 90%
    center #fff;
  border: 1px solid #999;
  color: #666;
  font: 15px/36px 'sans-serif';
  outline: none;
  text-align: center;
  vertical-align: top;
  height: 36px;
  width: 100%;
}
.sec_sel_addr_date .zone_addr_date ul li.col .searchable-select {
  border: 1px solid #999;
  color: #666;
  height: 38px;
  width: 100%;
}
.sec_sel_addr_date .zone_addr_date ul li.col .searchable-select-caret {
  right: 20px;
}
.sec_sel_addr_date .zone_addr_date ul li.col .searchable-select-holder {
  border: 0 none;
  font-size: 15px;
  padding: 0 5px;
  text-align: center;
  line-height: 38px;
}
.sec_sel_addr_date .zone_addr_date ul li.col .searchable-select-dropdown {
  top: 38px;
}
/*进行中的活动*/
.bx-going-activity .going-ct .isNothing {
  padding-top: 20px;
  text-align: center;
}
.bx-going-activity .going-ct .isNothing h2 {
  color: #fff;
  font-size: 20px;
  margin-bottom: 10px;
}
.bx-going-activity .going-ct .isNothing p a {
  color: $fontColor;
  font-size: 14px;
  text-decoration: underline;
}
.bx-going-activity .going-ct {
  margin-top: 30px;
  overflow: hidden;
}
.bx-going-activity .going-ct ul li {
  background: #474664;
  border-radius: 5px;
  border: 1px solid #ddd;
  margin-bottom: 30px;
  padding: 20px 30px;
  overflow: hidden;
  box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.2);
  -webkit-box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.2);
  -moz-box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.2);
  transition: background 0.3s;
  -webkit-transition: background 0.3s;
  -moz-transition: background 0.3s;
}
.bx-going-activity .going-ct ul li.on {
  background: #f8f8f8;
}
.bx-going-activity .going-ct ul li .bx-lt {
  width: 700px;
}
.bx-going-activity .going-ct ul li .bx-lt .title h2 {
  color: #fff;
  display: inline;
  font: 20px/30px 'sans-serif';
  height: 30px;
}
.bx-going-activity .going-ct ul li .bx-lt .title .btn_going {
  border: 1px solid $fontColor;
  border-radius: 3px;
  color: $fontColor;
  display: inline-block;
  font: 16px/26px 'sans-serif';
  margin-left: 10px;
  padding: 0 20px;
  height: 26px;
}
.bx-going-activity .going-ct ul li .bx-lt .line {
  color: #fff;
  font-size: 18px;
  margin-top: 10px;
}
.bx-going-activity .going-ct ul li .bx-lt .trip {
  margin-top: 20px;
}
.bx-going-activity .going-ct ul li .bx-lt .trip p {
  color: #fff;
  font-size: 16px;
  margin-top: 10px;
}
.bx-going-activity .going-ct ul li .bx-lt .trip label {
  display: inline-block;
  width: 350px;
}
.bx-going-activity .going-ct ul li .bx-lt .desc {
  border-top: 1px dashed #fff;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  margin-top: 15px;
  padding-top: 15px;
}
.bx-going-activity .going-ct ul li .bx-rt {
  text-align: center;
}
.name_rt {
  cursor: pointer;
}
.bx-going-activity .going-ct ul li .bx-rt .uimg {
  display: block;
  overflow: hidden;
  height: 120px;
  width: 120px;
}
.bx-going-activity .going-ct ul li .bx-rt .uimg img {
  border-radius: 50%;
}
.bx-going-activity .going-ct ul li .bx-rt .name {
  color: #8d65ea;
  font-size: 18px;
  margin-top: 20px;
}
.bx-going-activity .going-ct ul li .bx-rt .sex {
  color: #8d65ea;
  font-size: 14px;
  margin-top: 10px;
}
.bx-going-activity .going-ct ul li .bx-rt .sex em {
  margin-left: 10px;
}
/*右侧部分*/
.lay-gd-side .bx-side {
  margin: 0 auto 30px;
  width: 340px;
  margin-top: 60px !important;
}
.i-look-world .adimg {
  background: #fff;
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
.i-look-world .btn_launch {
  background: $fontColor;
  color: #fff;
  cursor: pointer;
  display: block;
  font: 18px/50px 'sans-serif';
  text-align: center;
  height: 50px;
  width: 100%;
  transition: background 0.3s;
  -webkit-transition: background 0.3s;
  -moz-transition: background 0.3s;
}
.i-look-world .btn_launch:hover {
  background: #ee5f00;
}
/*==*/
.hot-strategy .stg-inner {
  background: #fff;
  border: 1px solid #ddd;
  padding: 20px;
}
.hot-strategy .stg-inner .title {
  margin-bottom: 30px;
}
.hot-strategy .stg-inner .title em {
  color: $fontColor;
  font-size: 18px;
}
.hot-strategy .stg-inner .title a {
  color: #999;
  font-size: 14px;
  margin-top: 2px;
}
.hot-strategy .stg-inner .stg_list {
  overflow: hidden;
  zoom: 1;
  margin-top: -1px;
}
.hot-strategy .stg-inner .stg_list li {
  border-top: 1px dotted #aaa;
  padding: 15px 0;
}
.hot-strategy .stg-inner .stg_list li a {
  color: #999;
  font-size: 15px;
}
.hot-strategy .stg-inner .stg_list li a:hover {
  color: #333;
  text-decoration: underline;
}
.hot-strategy .stg-inner .stg_list li em {
  color: $fontColor;
}
/*==*/
.hot-spots .spot-inner {
  background: #fff;
  border: 1px solid #ddd;
  padding: 20px;
}
.hot-spots .spot-inner .title {
  margin-bottom: 30px;
}
.hot-spots .spot-inner .title em {
  color: $fontColor;
  font-size: 18px;
}
.hot-spots .spot-inner .title a {
  color: #999;
  font-size: 14px;
  margin-top: 2px;
}
.hot-spots .spot-inner .spots_list {
  overflow: hidden;
  zoom: 1;
  margin-top: -1px;
}
.hot-spots .spot-inner .spots_list li {
  border-top: 1px dotted #aaa;
  color: #999;
  font-size: 15px;
  padding: 15px 0;
}
.hot-spots .spot-inner .spots_list li .addr {
  background: url(../../../static/images/icon-pos2.png) no-repeat left center;
  display: block;
  margin-top: 5px;
  padding-left: 15px;
}
/* }}} */
</style>



// WEBPACK FOOTER //
// src/views/encounter/encounter.vue